import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  faTrash,
  faFileCircleExclamation,
  faFileCircleCheck,
} from '@fortawesome/free-solid-svg-icons';
import { faFile } from '@fortawesome/free-regular-svg-icons';

@Component({
  selector: 'app-drag-drop-file',
  templateUrl: './drag-drop-file.component.html',
  styleUrls: ['./drag-drop-file.component.scss'],
})
export class DragDropFileComponent {
  files: any[] = [];
  faTrash = faTrash;
  faFile = faFile;
  faFileCircleExclamation = faFileCircleExclamation;
  faFileCircleCheck = faFileCircleCheck;
  @Output() onSelectFile: EventEmitter<string> = new EventEmitter();
  @Output() onRemoveFile: EventEmitter<number> = new EventEmitter();
  @Output() onWaitingLoadFile: EventEmitter<boolean> = new EventEmitter();
  @Input() maxSize: number = 4;
  @Input() multiple: boolean = false;
  @Input() isBase64: boolean = true;
  errorMessages: any[] = [];

  onFileDropped(event: any) {
    this.prepareFilesList(event);
  }

  fileBrowseHandler(event: any) {
    const files: any[] = event.target?.files;
    this.prepareFilesList(files);
  }

  rmFile(index: number) {
    this.onRemoveFile.emit(index);
    this.files.splice(index, 1);
  }

  // Gestisce l'input del file e converte il file in base64
  handleFiles(index: number) {
    setTimeout(() => {
      if (index === this.files.length) {
        return;
      } else {
        const file = this.files[index];
        this.onWaitingLoadFile.emit(true);
        if (this.isBase64) {
          const reader = new FileReader();
          reader.onloadend = (e) => {
            let attachmentBase64 = e.target?.result as string;
            // Rimozione del prefisso base64 dalla stringa
            attachmentBase64 = attachmentBase64.replace(/^data:[a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+;base64,/, '');
            this.onSelectFile.emit(attachmentBase64);
            this.onWaitingLoadFile.emit(false);
            this.handleFiles(index + 1);
          };
          reader.onprogress = (e) => {
            if (e.lengthComputable) {
              file.progress = Math.round((e.loaded / e.total) * 100); // Calcola e aggiorna l'avanzamento del caricamento del file
            }
          };
          reader.readAsDataURL(file); // Conversione in base64
        } else {
          const progressInterval = setInterval(() => {
            if (file.progress === 100) {
              clearInterval(progressInterval);
              this.onSelectFile.emit(file);
              this.onWaitingLoadFile.emit(false);
              this.handleFiles(index + 1);
            } else {
              file.progress += 15;
            }
          }, 100);
        }
      }
    }, 500);
  }

  prepareFilesList(files: Array<any>) {
    this.errorMessages = [];
    if (!this.multiple) files = [...files].slice(0, 1);
    for (const item of files) {
      const fileSizeMb = item.size / 1024 ** 2;
      if (fileSizeMb > this.maxSize) {
        this.errorMessages.push({
          file: item,
          msg: 'INCIDENT.ERROR.FILE_DIMENSION_EXEEDED',
        });
      } else {
        item.progress = 0;
        this.files.push(item);
      }
    }
    this.handleFiles(0);
  }

  formatBytes(bytes: number, decimals: number = 0) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }
}